import { Grid } from "@mui/material"
import CircularProgress from "@mui/material/CircularProgress"

export function LoadingIcon() {
  return (
    <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center">
      <CircularProgress />
    </Grid>
  )
}
